import React, { useContext, useEffect, useState } from 'react';
import { FirebaseContext } from '../../context/firebase';
import { useHistory, withRouter } from 'react-router';
import Sidebar from '../layout/sidebar/Sidebar.jsx';
import AddPeople from '../agenda/addPeople/AddPeople';
import AppointmentsList from '../agenda/appointmentList/AppointmentsList';
import JoinShortCode from '../agenda/joinFromCode/JoinShortCode';
import HelloOauth from './HelloSignOauthTest/helloOauth';
import CheckForNewClients from './checkNewClients/checkForNewClients';
import * as DONE_ONCE from '../../constants/doneOnceJson';
import * as firebaseDocumentCalls from '../../api/Clients/getFirebaseDocumentInfo.api';
import * as ALL_DOCUMENTS from '../../constants/helloSignDocumentInfo';

import './Home.css';
import Clients from '../clients/Clients';

//redux
import { connect } from 'react-redux';

const Home = ({ userType }) => {
	const { firebase } = useContext(FirebaseContext);

	useEffect(() => {
		firebase.auth().onAuthStateChanged(async (user) => {
			if (user) {
				if (
					ALL_DOCUMENTS.allDocumentTypeInfo.hasGottenInfo === false &&
					userType !== 'client' &&
					userType !== null &&
					userType !== undefined
				) {
					firebaseDocumentCalls.GetFirebaseDocumentInformation();
				}
			}
		});
	}, []);

	return (
		<div id='home'>
			<Sidebar />
			<div className='home-main'>
				<div>
					<h2 id='home-title'>Dashboard</h2>
					{userType === 'admin' ||
					userType === 'superadmin' ||
					userType === 'salesadmin' ? (
						<>
							<JoinShortCode />
							<div className='main-cards'>
								<AddPeople />
								<AppointmentsList />
							</div>
						</>
					) : (
						<JoinShortCode />
					)}
					<HelloOauth />
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	userType: state.signIn.userType,
});

export default connect(mapStateToProps)(Home);
